import React from 'react';
import PropTypes from 'prop-types';
import { logout, getOxygenUrl, getAccOrigin, getUserProfileUrl } from '@adsk/acs-sc-web-platform-api';
import * as analytics from '@adsk/acs-web-analytics';
import { clearNetworkCache } from '@adsk/alloy-helpers';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import A from '@adsk/alloy-react-a';
import { Box } from '@adsk/alloy-react-box';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { ANALYTICS_TYPES } from '../helpers/analytics';
import getNotificationSettingsUrl from '../helpers/getNotificationSettingsUrl';
import { userShape } from '../helpers/propTypes';
/**
 * Acs TopNavigation
 */
const Profile = _ref => {
  let {
    showSubscriptionsModal,
    user,
    projectId,
    onLogout,
    onClose,
    onOpenSubscriptions,
    UNSAFE_showBuildersUserProfileModal: showBuildersUserProfileModal,
    UNSAFE_isBuildersProfileModalEnabled: isBuildersProfileModalEnabled
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const {
    value: newProfileUrlFF
  } = useAlloyFeatureFlag('show-new-profile-url');
  return /*#__PURE__*/React.createElement(Box, {
    width: "250px",
    padding: "24px"
  }, /*#__PURE__*/React.createElement(Box, {
    typography: "heading4",
    color: "charcoal900"
  }, user.firstName, " ", user.lastName), /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall",
    color: "charcoal600"
  }, user.email), showSubscriptionsModal && /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall",
    color: "charcoal600",
    marginTop: "10px"
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      cursor: 'pointer'
    },
    onClick: () => {
      onClose();
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_MYSUBSCRIPTIONS_CLICK);
      onOpenSubscriptions();
    },
    "data-testid": "My__Subscriptions__Label",
    rel: "noopener noreferrer"
  }, T.translate('MY_SUBSCRIPTIONS'))), projectId && /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall",
    color: "charcoal600",
    marginTop: "10px"
  }, /*#__PURE__*/React.createElement(A, {
    href: getNotificationSettingsUrl(projectId),
    rel: "noopener noreferrer",
    onClick: () => analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_NOTIFICATIONSETTINGS_CLICK)
  }, T.translate('NOTIFICATION_SETTINGS'))), isBuildersProfileModalEnabled && /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall",
    color: "charcoal600",
    marginTop: "10px"
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      cursor: 'pointer'
    },
    onClick: () => {
      onClose();
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_EDIT_PROFILE_CLICK);
      showBuildersUserProfileModal === null || showBuildersUserProfileModal === void 0 ? void 0 : showBuildersUserProfileModal();
    },
    "data-testid": "Builders_Network_Edit__Profile__Label",
    rel: "noopener noreferrer"
  }, T.translate('EDIT_PROFILE'))), /*#__PURE__*/React.createElement(Box, {
    paddingTop: "32px"
  }, !isBuildersProfileModalEnabled && /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: newProfileUrlFF ? getUserProfileUrl() : getOxygenUrl(),
    rel: "noopener noreferrer",
    target: "_blank",
    variant: Button.VARIANTS.PRIMARY,
    size: Button.SIZES.SMALL,
    style: {
      marginRight: 12
    },
    onClick: () => {
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_PROFILESETTINGS_CLICK);
      onClose();
    }
  }, T.translate('PROFILE_SETTINGS')), /*#__PURE__*/React.createElement(Button, {
    variant: Button.VARIANTS.SECONDARY,
    size: Button.SIZES.SMALL,
    onClick: () => {
      clearNetworkCache();
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_SIGNOUT_CLICK);
      if (onLogout) {
        onLogout();
      }
      logout(getAccOrigin());
      onClose();
    }
  }, T.translate('SIGN_OUT'))));
};
Profile.displayName = 'Profile';
Profile.propTypes = {
  /** show subscriptions modal (page level) */
  showSubscriptionsModal: PropTypes.bool,
  /** current user */
  user: userShape,
  /** current selected project id */
  projectId: PropTypes.string,
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** menu close handler */
  onClose: PropTypes.func.isRequired,
  /** opens my subscriptions modal */
  onOpenSubscriptions: PropTypes.func.isRequired,
  /** Triggers opening the Builders Network Profile Modal */
  UNSAFE_showBuildersUserProfileModal: PropTypes.func,
  /** When BuildersNetworkProfile is enabled, it updates the TopNav Profile dropdown options to include button for opening the BN Modal and hides the Profile settings button*/
  UNSAFE_isBuildersProfileModalEnabled: PropTypes.bool
};
export default Profile;
//# sourceMappingURL=Profile.js.map